import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ShoppingCartCheckoutOutlinedIcon from "@mui/icons-material/ShoppingCartCheckoutOutlined";
import { Box, Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const actions = [
  { title: "Add Spare Part", subtitle: "Create new spare item", icon: <AddBoxOutlinedIcon />, path: "/spare-parts/master?create=1", color: "#2563EB", soft: "#EFF6FF" },
  { title: "Create Category", subtitle: "Manage categories", icon: <CategoryOutlinedIcon />, path: "/spare-parts/categories", color: "#7C3AED", soft: "#F5F3FF" },
  { title: "Add Supplier", subtitle: "Register supplier", icon: <LocalShippingOutlinedIcon />, path: "/spare-parts/suppliers", color: "#059669", soft: "#ECFDF5" },
  { title: "Inventory", subtitle: "View stock", icon: <Inventory2OutlinedIcon />, path: "/spare-parts/inventory", color: "#EA580C", soft: "#FFF7ED" },
  { title: "Purchase Bill", subtitle: "Register inward bill", icon: <ShoppingCartCheckoutOutlinedIcon />, path: "/spare-parts/procurement", color: "#E11D48", soft: "#FFF1F2" },
  { title: "Analytics", subtitle: "Reports and trends", icon: <InsightsOutlinedIcon />, path: "/spare-parts/analytics", color: "#2563EB", soft: "#EFF6FF" },
];

const QuickActions = () => {
  const navigate = useNavigate();

  return (
    <Card elevation={0} sx={(theme) => ({ borderRadius: 3, border: "1px solid", borderColor: theme.palette.mode === "dark" ? "#2a3953" : "divider", bgcolor: theme.palette.mode === "dark" ? "#111b2d" : "background.paper", overflow: "hidden" })}>
      <CardContent sx={{ p: { xs: 2, md: 2.25 }, "&:last-child": { pb: { xs: 2, md: 2.25 } } }}>
        <Stack direction="row" spacing={1.25} alignItems="center" mb={2}>
          <Box sx={{ width: 38, height: 38, display: "grid", placeItems: "center", borderRadius: 2, bgcolor: "success.light", color: "success.dark" }}>
            <BoltRoundedIcon fontSize="small" />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={800}>Quick Actions</Typography>
            <Typography variant="caption" color="text.secondary">Common tasks for spare parts management</Typography>
          </Box>
        </Stack>

        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))", xl: "repeat(6, minmax(0, 1fr))" }, gap: 1.25 }}>
          {actions.map((item) => (
            <Card key={item.title} variant="outlined" sx={{ borderRadius: 2, borderColor: item.color + "35", bgcolor: item.soft, color: "#172033", boxShadow: "none", overflow: "hidden", "&:hover": { borderColor: item.color, boxShadow: `0 9px 20px ${item.color}1A` } }}>
              <CardActionArea onClick={() => navigate(item.path)} sx={{ height: "100%", px: 1.25, py: 1.15 }}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
                  <Box sx={{ display: "grid", placeItems: "center", flex: "0 0 auto", width: 32, height: 32, borderRadius: 1.5, color: item.color, bgcolor: "rgba(255,255,255,.60)", "& svg": { fontSize: 19 } }}>{item.icon}</Box>
                  <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography variant="caption" fontWeight={850} sx={{ display: "block", color: "#172033", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.title}</Typography>
                    <Typography variant="caption" sx={{ display: "block", color: "#52627a", fontSize: "0.65rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.subtitle}</Typography>
                  </Box>
                  <ArrowForwardIosRoundedIcon sx={{ fontSize: 13, color: item.color }} />
                </Stack>
              </CardActionArea>
            </Card>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default QuickActions;
